//パスワードのバリデーションチェック
//10～20文字
//アルファベットの大文字、小文字、数字、記号を含んでいるかどうか
export const passwordCheck = function (password) {
    if(password.length < 10 || password.length > 20)
    {
        return false;
    }

    if(!password.match("[a-z]{1,}"))
    {
        return false;
    }

    if(!password.match("[A-Z]{1,}"))
    {
        return false;
    }

    if(!password.match("[0-9]{1,}"))
    {
        return false;
    }

    //使用可能な記号「!"#$%&'()*+,-./」
    if(!password.match("[!\"#$%&'()*+,-./]{1,}"))
    {
        return false;
    }

    // それ以外の文字を含んでいないかどうか
    const replacedPass = password.replace(/[a-zA-Z0-9!\"#$%&'()*+,-./]/g, "");
    if (replacedPass.length > 0) {
        return false;
    }
 
    //OK
    return true;
};